import { Button, Card, Spinner, Typography } from '@material-tailwind/react';
import React, { useEffect, useState, useMemo } from 'react'
import { useShared } from '../../hooks/useShared';
import ABreadcrumbs from '../breadcrumbs/ABreadcrumbs';
import UploadPhoto from '../upload/UploadPhoto';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import AInput from '../fields/AInput';
import ASelect from '../fields/ASelect';
import ASwitch from '../fields/ASwitch';
import AIcon from '../partials/AIcon';
import ARadio from '../fields/ARadio';
import APDate from '../fields/APDate';
import ItemsComp from '../fields/ItemsComp';


export default function AddNew({ v }) {

    const { http, photo, setPhoto, uploadPhoto, navigate, consts, location, setMessage, fetchModelCounts } = useShared();

    const [breadcrumbs, setBreadcrumbs] = useState([{ name: 'دشـبورد', link: '/dashboard' }])
    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)

    const { register, handleSubmit, control, formState: { errors }, reset, setValue, getValues } = useForm({
        defaultValues: useMemo(() => {
            return location?.state?.model;
        }, [location?.state])
    });
    const modelName = location?.state?.modelName

    console.log("model name ", modelName)

    useEffect(() => {
        setBreadcrumbs(pre => [...pre, { name: modelName?.af, link: `/${modelName?.name}` }])
    }, [])

    useMemo(() => {
        if (location?.state) {
            const img = location?.state?.model?.image_data?.path
            setPhoto({ url: img ? consts.BASE_URL + img : '', photo: null })  
        }
    
    }, [location?.state])

    const mReset = () => {
        reset({})
    }

    const submit = async (submitData) => {

        setErrorMessage(null)

        console.log(modelName, ', submit ', submitData);

        try {
            setLoading(true)
            const res = await http.post(`api/${modelName?.name}`, submitData);

            console.log('model  ', res);

            if (res.data?.success) {
                const model = res.data?.data;


                // upload image if exists
                setLoading(false)
                toast.success(res.data.message);
                setMessage(res.data.message)
                fetchModelCounts()
                if (model?.id && photo) {  upload(model)}
                else  navigate(-1)
               
              
            }



        } catch (error) {
            console.log(error);
            setLoading(false)
            const err = error?.response?.data

            if (!err?.success) {
                setErrorMessage(err?.message)
                toast.error(err?.message);
            }
        }
        return false
    }

    const upload = (model) => {
        if (model?.id && photo) {
            console.log(model)

            uploadPhoto({ id: model?.id, name: modelName?.name }).then(res => {
                console.log(res)
                setPhoto(null)
                navigate(-1)
            });
        }
    }


    return (
        <div style={{direction:'rtl'}}>
            <ABreadcrumbs links={breadcrumbs} />
            <div className='md:flex  items-start gap-4'>
                <Card className="w-full md:w-[70%]  p-2 md:p-4 mt-4 relative">
                    <p className="text-sm text-main-color font-bold capitalize">Add / Update {modelName?.name} Information</p>
                    <form className=" flex flex-col gap-4 mt-4" onSubmit={handleSubmit(submit)}>
                        <div className=" grid  gap-6 items-baseline">

                            <div className='grid md:grid-cols-1 gap-4'>
                                <fieldset className='border p-3 rounded-lg grid gap-4' >

                                    {
                                        location?.state?.fields?.map((data, i) => {
                                            return (
                                                <React.Fragment key={i}>
                                                    {
                                                        data?.type === 'text' || data.type === 'date' || data?.type === 'textarea' || data?.type === 'password' || data?.type === 'email' ?
                                                            <AInput v={{ register, errors, data }} />
                                                            : data?.type === 'select' ? <ASelect v={{ register, errors, control, data }} />
                                                                : data?.type === 'switch' ? <ASwitch v={{ register, errors, data }} />
                                                                    : data?.type === 'radio' ? <ARadio v={{ register, errors, data, control }} />
                                                                        : data?.type === 'pdate' ? <APDate v={{ register, errors, control, setValue, data }} />
                                                                            : data?.type === 'items_comp' ? <ItemsComp v={{ register, errors, control, getValues, data, items: 'items' }} />
                                                                                : null
                                                    }
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                    <UploadPhoto v={{ obj: location?.state?.model?.image_data, className: "md:hidden ", title: 'Upload photo' }} />
                                </fieldset>
                            </div>
                        </div>
                        {errorMessage && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal "
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errorMessage}
                        </Typography>}
                        <div className='flex gap-4 md:justify-start'>
                            <Button className="btn1 w-full md:w-[10%] amiriB text-white text-base" size='sm' type="submit" disabled={loading}>  {loading ? <Spinner color="teal" className="h-4 w-4" /> : "ارسال"}    </Button>
                            <Button variant="outlined" size='sm' color="gray" onClick={() => mReset()}>Reset</Button>
                        </div>


                    </form>

                </Card>
                <UploadPhoto v={{ obj: location?.state?.model?.image_data, title: 'Upload photo', className: "hidden md:block w-full  md:w-[30%]  p-2 md:p-4  relative" }} />
            </div>
            <ToastContainer />
        </div>
    )
}
